import ResponsiveNavigation from '@/components/ResponsiveNavigation';
import HeroSection from '@/components/HeroSection';
import ProblemSection from '@/components/ProblemSection';
import { SEO, SEO_CONFIG } from '@/components/SEO';
import { lazy, Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Below-the-fold: lazy-loaded to reduce initial JS for landing
const IdealCustomerSection = lazy(() => import('@/components/IdealCustomerSection'));
const CoreStrengthsSection = lazy(() => import('@/components/CoreStrengthsSection'));
const WorkflowSection = lazy(() => import('@/components/WorkflowSection'));
const NDVIShowcaseSection = lazy(() =>
  import('@/components/NDVIShowcaseSection').then(m => ({ default: m.NDVIShowcaseSection }))
);
const SampleReportSection = lazy(() => import('@/components/SampleReportSection'));
const BuiltOnSection = lazy(() => import('@/components/BuiltOnSection'));
const WhatMakesUsDifferent = lazy(() => import('@/components/WhatMakesUsDifferent'));
const RoadmapSection = lazy(() => import('@/components/RoadmapSection'));
const MeetGauchoSection = lazy(() => import('@/components/MeetGauchoSection'));
const TestimonialsSection = lazy(() => import('@/components/TestimonialsSection'));
const PricingSection = lazy(() => import('@/components/PricingSection'));
const FAQSection = lazy(() => import('@/components/FAQSection'));
const Footer = lazy(() => import('@/components/Footer'));
const HelpCenterChat = lazy(() => import('@/components/HelpCenterChat'));
const PWAInstallBanner = lazy(() =>
  import('@/components/PWAInstallBanner').then(m => ({ default: m.PWAInstallBanner }))
);

const SectionFallback = () => <div className="min-h-[200px]" aria-hidden="true" />;

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      // Wait for sections to render
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (attempt < 10) {
          setTimeout(() => tryScroll(attempt + 1), 100);
        }
      };
      tryScroll();
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background">
      <SEO {...SEO_CONFIG.home} url="/" />
      <ResponsiveNavigation />
      <main id="main">
        <HeroSection />
        {/* Narrative: Problem → Audience → Evidence → Proof → FAQ → Pricing */}
        <ProblemSection />
        <Suspense fallback={<SectionFallback />}>
          <WorkflowSection />
          <CoreStrengthsSection />
          <NDVIShowcaseSection />
          <IdealCustomerSection />
          <SampleReportSection />
          <BuiltOnSection />
          <WhatMakesUsDifferent />
          <MeetGauchoSection />
          <RoadmapSection />
          <TestimonialsSection />
          <PricingSection />
          <FAQSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <HelpCenterChat />
        <PWAInstallBanner />
      </Suspense>
    </div>
  );
};

export default Index;
